const ReachErrorImage = () => {
	return (
		<svg width="181" height="102" fill="none" viewBox="0 0 181 102">
			<g clipPath="url(#a)">
				<g stroke="#69727d" clipPath="url(#b)">
					<path
						fill="#fff"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.98"
						d="M144.738 83.26H39.848l2.332-64.957h104.89z"
					/>

					<path
						fill="#69727d"
						strokeMiterlimit="10"
						strokeWidth=".911"
						d="M146.85 22.63H41.951l.228-4.327h104.89z"
					/>

					<path
						fill="#fff"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.98"
						d="M61.6 99.965a3.9 3.9 0 0 1-.328-5.638l24.011-25.679 3.352 2.833-21.378 27.883a3.886 3.886 0 0 1-4.274 1.373 3.9 3.9 0 0 1-1.383-.772"
					/>

					<path
						fill="#fff"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.98"
						d="M100.396 76.2c11.676 0 21.142-9.466 21.142-21.142s-9.466-21.142-21.142-21.142-21.142 9.466-21.142 21.142S88.719 76.2 100.396 76.2"
					/>

					<path
						fill="#fff"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.98"
						d="M100.395 71.955c9.332 0 16.897-7.565 16.897-16.897s-7.565-16.897-16.897-16.897-16.897 7.565-16.897 16.897 7.565 16.897 16.897 16.897"
					/>

					<path
						fill="#f1f3f3"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.98"
						d="m31.272 61.565 70.334-4.202L50.7 15.648z"
					/>

					<path
						fill="#f1f3f3"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.98"
						d="M51.321 53.802c10.422-10.389 10.451-27.256.066-37.673s-27.252-10.442-37.674-.053C3.292 26.465 3.263 43.33 13.648 53.749s27.252 10.442 37.673.053"
					/>

					<path
						fill="#fff"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.98"
						d="M29.576 41.507c-1.275-4.672-.665-6.604 2.032-9.8 2.186-2.643 3.917-4.273 3.917-7.07 0-2.586-1.166-4.217-2.997-4.217s-2.186 1.822-2.797 3.461c-.81 1.977-1.63 2.733-3.407 2.733a5.96 5.96 0 0 1-4.873-2.386c.911-3.107 4.318-6.76 11.077-6.76S43.24 21.44 43.24 26.114c0 4.163-2.733 6.704-6.376 9.81-2.797 2.433-3.917 3.644-4.318 5.584l-.155.71H29.75zm-2.732 8.199a4.783 4.783 0 0 1 9.555 0 4.782 4.782 0 0 1-9.555 0"
					/>
				</g>
			</g>

			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h181v101.813H0z" />
				</clipPath>

				<clipPath id="b">
					<path fill="#fff" d="M.5.094h181v101.813H.5z" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default ReachErrorImage;
